import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router' ;


import { ApiService, DialogsService } from '../../custom-material/Services/';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';


import { ObjectifModel, UserModel, BuildingModel, Colors } from '../../main/Models/';
import { ObjectifComponent } from '../objectif/objectif.component';
import { ObjectifFormComponent } from '../objectif-form/objectif-form.component';
import { globalData, selectionObserver } from 'src/app/main/Models/global.model';
import { toollist } from './rmmain.tool';
import { TranslocoService } from '@ngneat/transloco';


@Component({
  selector: 'rm-main',
  templateUrl: './t_rmmain.component.html',
  styleUrls: ['./rmmain.component.less']
})
export class RMMainComponent implements OnInit, selectionObserver {
/*
  @ViewChild('objSheet') objectifSheet: ObjectifComponent;

  openedObjectif: ObjectifModel = null;

  get autoSelect()
  {
    if(this.route.snapshot.params['building']!=undefined) {
      return +this.route.snapshot.params['building'];
    } else {
      return 'mine';
    }
  }
*/
  
  objectifs:Array<ObjectifModel> = [];
  allRatios:Array<number[]> = [];
  _objectifOrder:string = 'slice';
  set objectifOrder(oo:string)
  {
    this._objectifOrder = oo;
    this.calcInit();
  }
  get objectifOrder()
  {
    return this._objectifOrder;
  }
  searchFilter:string;

  sliceFilter:any[] = [
    {'label': 'Alarmant', 'show': true, 'color': Colors.colors[0], 'count': 0},
    {'label': 'Préocupant', 'show': true, 'color': Colors.colors[1], 'count': 0},
    {'label': 'Important', 'show': true, 'color': Colors.colors[2], 'count': 0},
    {'label': 'Positif', 'show': true, 'color': Colors.colors[3], 'count': 0},
    {'label': 'Hors audit', 'show': true, 'color': '#1b6ba8', 'count': 0},
  ];
  filteredObjectifs:Array<ObjectifModel> = [];
  totalBudgets:number = 0;

  constructor(private apiService: ApiService,
              private router: Router,
              private route: ActivatedRoute,
              private snackBar: MatSnackBar,
              //private dialog: MatDialog,
              private dialogService: DialogsService,
              public gd: globalData,
              private translateService:TranslocoService
              ) {
                this.gd.headerTitle = 'Management des risques';
                this.gd.headerIcon = 'multiline_chart';
                this.gd.toollist = toollist;
                this.gd.toolService = this;
                this.gd.showChooser = true;
               }

  ngOnInit() {
    this.gd.subscribe(this);
    this.buildingsSelectionChanged();
    /*const uriBuildingId = this.route.snapshot.params['building'];
    if(uriBuildingId!=undefined) {
      this.gd.headerBuilding = this.gd.findBuildingById(uriBuildingId);
      if(this.gd.headerBuilding) this.gd.selectedBuildingsList = [uriBuildingId];
      
    }*/
    
  }

  buildingsSelectionChanged()
  {
    setTimeout(()=>{ this.snackBar.open('Chargement en cours') }, 0);
    this.loadAllObjectifs(this.gd.selectedBuildingsList)
      .then(()=>{
        this.calcInit();
        setTimeout(()=>{ this.snackBar.dismiss(); }, 0);
      })
      .catch(()=>{
        setTimeout(()=>{ this.snackBar.open('Selectionner un ou plusieurs établissements') }, 0);
        setTimeout(()=>{ this.snackBar.dismiss(); }, 3000);
      });
  }

  loadAllObjectifs(selectedBuildingsList:number[])
  {
    return new Promise((resolve, reject)=>{
    let params = '';
    if(selectedBuildingsList.length==0) {
      this.objectifs = [];
      this.filteredObjectifs = [];
      reject(); return;
    }

    params = 'filter[0][type]=in'
      +'&filter[0][field]=building';
    let b=0;
    selectedBuildingsList.forEach(buildingId => {
        params += '&filter[0][values]['+b+']='+buildingId;
        b++;
    });
     

    this.apiService.getFromServer('objectif', params)
       .then(s => s.subscribe((response:any) => {
         this.objectifs = [];
          for( let i in response._embedded.objectif) {
            this.objectifs[i] = new ObjectifModel(response._embedded.objectif[i]);
          }
          resolve(true);
       })); 

    });
  }
/*
  newObjectif()
  {
    const dialogRef = this.dialog.open(ObjectifFormComponent, {
      width: '900px',
      height: '400px',
      data: { 
        building: this.gd.uniqSelectedBuilding,
      }
    });

    dialogRef.afterClosed().subscribe((objectif:ObjectifModel) => {
      if(!objectif) return;

      this.snackBar.open('Sauvegarde en cours')
      this.apiService.SaveToServer('objectif', objectif.export())
        .then(s => s.subscribe((response:any) => {
          this.snackBar.open('Objectif sauvegardé');
          let newObjectif = new ObjectifModel(response);
          this.openedObjectif = newObjectif;
          this.objectifs.push(newObjectif);
          setTimeout(()=>{ this.snackBar.dismiss() }, 2000);
        }))
    });
  }
/*
  displayObjectifSheet(objectif:ObjectifModel)
  {
    this.openedObjectif = objectif;
    window.document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }
  closeObjectifSheet()
  {
    this.openedObjectif=null;
    window.document.getElementsByTagName('body')[0].style.overflow = 'auto';
    this.calcInit();
  }
*/
  newObjectif()
  {
    if(!this.gd.hasUniqSelectedBuilding) {
      this.dialogService.alert('Veuillez sélectionner un seul établissement pour pouvoir créer un objectif');
      return;
    }


    this.snackBar.open('Création du nouvel objectif');
    let now = new Date();
    let today = now.toISOString().split('T')[0];
    let newObjectif = new ObjectifModel({
      name: this.translateService.translate('Nouvel objectif'),
      building: this.gd.uniqSelectedBuilding,
      start:{date: today},
      end: {date: today},
      status: 0
    });
    this.apiService.SaveToServer('objectif', newObjectif.export())
      .then(s => s.subscribe((response:any) => {
        setTimeout(()=>{ this.snackBar.dismiss() }, 0);
        this.snackBar.open('Objectif sauvegardé');
        let newObjectif = new ObjectifModel(response);
        this.displayObjectifSheet(newObjectif);
      }) );
  }
  displayObjectifSheet(objectif:ObjectifModel)
  {
    this.gd.current = objectif;
    this.router.navigate(['rm','objectifs',objectif.id]);
  }
  calcInit()
  {
    let allRatios = [];
    this.sliceFilter.forEach((s)=>{s.count=0});
    this.filteredObjectifs = [];
    this.totalBudgets = 0;

    this.objectifs.forEach((o:ObjectifModel)=>{
      //slice count
      let slice;
      if(o.answer) {
        ////slice = this.sliceFilter.filter((s)=>{return s.label==o.answer.slice.name})[0];
        slice = this.sliceFilter.find((s)=>{return s.label==o.answer.slice.name});
      } else {
        //Hors audit
        slice = this.sliceFilter[4];;
      }
      slice.count++;

      if(slice.show
      && (!this.searchFilter 
        || o.name.match(new RegExp(this.searchFilter, 'gi')) )
      ) {
        this.filteredObjectifs.push(o);
        this.totalBudgets += +o.budget;
      }


    });

    this.allRatios = allRatios;

    switch (this._objectifOrder) {
      case "slice":
        this.filteredObjectifs = this.filteredObjectifs.sort((a,b)=>{
          let scoreA = a.answer ? a.answer.score : 0;
          let scoreB = b.answer ? b.answer.score : 0;
          return scoreB - scoreA;
        });
        break;

      case "date" : 
        this.filteredObjectifs = this.filteredObjectifs.sort((a,b)=>{
          let dateA = new Date(a.start);
          let dateB = new Date(b.start);
          return dateA > dateB ? 1 : -1;
        });
        break;

      case "budget" : 
        this.filteredObjectifs = this.filteredObjectifs.sort((a,b)=>{
          return b.budget - a.budget;
        });
        break;
      
      default:
        // code...
        break;
    }
  }

  checkSearchFilter($event=null)
  {
    if($event==null || $event.code=='Enter' || $event.code=='NumpadEnter') 
      this.calcInit();
  }

}
